<template lang="pug">
  v-dialog(v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition")
    v-btn(v-if="dialogType === 'form'" slot="activator" dark color="indigo" title='View Detail')
      v-icon print
      | &nbsp; Print Preview
    
    template(v-slot:activator="{ on, attrs }")
        v-btn(
            class="custom__padding-btn elevation-0"
            v-bind="attrs"
            v-on="on"
            slot="activator" 
            dark
            color="green"
            class="ml-2"
        ) Preview

    v-card
      v-app-bar(
            :color='colorTheme'
            class="navFixed"
            height="48px;"
          )
        img(
                class="mr-2" 
                :src="require('../assets/imemo-white.png')" 
                height="34"
                @click="$router.push('/')" 
                style="cursor: pointer;"
              )
        v-toolbar-title(style="cursor: pointer; font-size: 18px; font-weight: 600; color: white") i-Memo Preview
        v-spacer
        v-toolbar-items
          v-btn(dark text  @click.native="dialog = false")
            v-icon(title="Close") cancel
            | &nbsp;Close
      v-list(three-line subheader class="print-bg padTop60")
        div(id="1" style="height: 100vh;")
          .page(size="Auto")
            table(id="header-view" class="view-width print-header" style="margin-bottom: 1.2rem;")
              tbody
                tr
                  td(class="custom-td" :style="`justify-content: ${item.logo_position}; display:flex`")
                    div(style="display: flex; width: 33%; flex-direction: column; align-items: center; flex-direction: column;")
                      img(v-if="pv" :src="lg" class="height-60px") 
                      p(v-show="item.show_name" class="logo-title" style="text-align:center") {{ item.bu_name }}
                      p(v-show="item.show_tagline" class="fw-300 tagline" style="text-align:center") {{ item.tagline }}               
                
            div(class="view-width" style="font-size:14px;")
              h2(style="text-align:center;padding:5px;") INTERNAL MEMO
              hr(class="custom-hr")

              table(class="view-width" style="margin-top:10px;")
                tbody
                  tr
                    td(style="font-size:15px;width:40%;") 
                      strong To 
                      i(class="fw-300") Kepada
                    td(style="font-size:15px;")
                      strong From 
                      i(class="fw-300") Dari

                  tr
                    td(valign="top")
                      ul(class="mt-n1")
                        li(style="font-size:15px;")
                          span User 1
                    td(valign="top")
                      ul(class="list-creator mt-n1")
                        li
                          span User 2
                        li  
                          strong Number
                          i(class="fw-300")  Nomor
                          br
                          | IM-{{ item.code }}-22120032
                        li
                          strong Date
                          i(class="fw-300")  Tanggal
                          br
                          | {{ getTanggal() }}
                        li
                          strong Subject
                          i(class="fw-300")  Subjek
                          br
                          | Demo Memo
      
          
</template>

<script>
export default {
  name: "PreviewLogo",
  props: {
    item: Object,
    lg: String,
    pv: String,
  },
  data: () => ({
    dialog: false,
  }),
  computed: {
     colorTheme: function() {
      return "#D42A2A";
    },
  },
  methods: {
    getTanggal: function() {
      let tanggal = new Date();
      let date = tanggal.getDate() < 10 ? '0'+tanggal.getDate() : tanggal.getDate();
      const month = tanggal.toLocaleString('default', { month: 'short' });
      let hour = tanggal.getHours();
      let minutes = tanggal.getMinutes();
      return date+' '+month+' '+tanggal.getFullYear()+' '+hour+':'+minutes;
    },
  },
};
</script>

<style scoped>
.logo-title{
    font-size: 22px;
    font-weight: 600;
    color: #121212;
    margin-bottom: -0.4rem;
    text-align: left;
}

.print-bg {
  background: rgb(204,204,204) !important;
}
.print-bg > div{
  text-align:center;
}
.page {
  background: white;
  display: block;
  margin: 5px auto;
  padding: 0.7cm 1cm 0.8cm;
  position: relative;
}
.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
.page[size="Auto"] {
  width: auto;
  margin:0 auto;
  display:inline-block;
  text-align:initial;
}
.view-width {
  width: 19cm;
}
.print-header {
  border-collapse: collapse;
  text-align: right;
}
.padding-x-3 {
  padding:0 3px;
}
.padding-xy-5 {
  padding:2px;
}
.padding-xy-1 {
  padding:1px;
}
.margin-tl-5 {
  margin: 3px 5px 0 5px;
}
.margin-tl-10 {
  margin: 3px 10px 0 10px;
}
.margin-tl-25 {
  margin: 3px 15px 0 25px;
}
.logo-cell {
  padding:8px 5px 0px;
  width:35%;
}
.detail-wrap {
  margin-top: 5px;
}
.border-left-0 {
  border-left: 0;
}
.border-right-0 {
  border-right: 0;
}
.approved {
  font-size: 11px;
  padding: 13px;
}
.ff0000 {
  color: #ff0000;
}
.align-center {
  text-align: center;
}
.width-20p {
  width:20%;
}
.width-25p {
  width:25%;
}
.height-40px {
  height: 40px;
}
.width-300px {
  width: 250px;
}
.width-150px {
  width: 150px;
}
.top-align {
  vertical-align:top;
}

.tgLbl {
  position: relative;
  margin: 0 30px 0 10px;
  cursor: pointer;
  font-size: 14px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* The containerLbl */
.containerLbl {
  position: relative;
  padding-left: 20px;
  margin: 0 30px 0 10px;
  cursor: pointer;
  font-size: 12px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.containerLbl input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 15px;
  width: 15px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.containerLbl:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.containerLbl input:checked ~ .checkmark {
  background-color: #000000;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.containerLbl input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.containerLbl .checkmark:after {
  left: 5px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.navFixed {
  position: fixed;
  z-index: 9;
}
.padTop60 {
  padding-top:60px;
}
.blink {
	-webkit-animation: blink 2s steps(5, start) infinite;
  animation: blink 2s steps(5, start) infinite;
  color: #fff;
}
@-webkit-keyframes blink { to { color: #ffffff; }}
@keyframes blink { to { color: #ffffff; }}
@media print {
  .page[size="Auto"] {
    width: auto;
    margin:0 auto;
    display:block;
    text-align:initial;
  }
  table { page-break-inside:auto; }
  tr    { page-break-inside:avoid; page-break-after:auto; }
  .pagebreak { page-break-before: always; } /* page-break-after works, as well */
  p { page-break-after: auto; page-break-before: auto; page-break-inside: avoid; }
  .image {padding: 5%; page-break-after: auto; page-break-before: auto; page-break-inside: avoid;}
  .table {page-break-after: auto; page-break-before: auto; page-break-inside: avoid;}
}
#background {
  position:absolute;
  z-index:0;
  display:block;
  top:0px;
  left:0px;
  text-align: right;
  width: 100%;
}

/* ========== CUSTOM CSS =========== */
.fw-300{
  font-weight:300;
}

ul.list-creator{
  list-style-type: none;
  padding-left: 0;
}

ul.list-creator li{
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #E1E1E1;
}


ul.list-creator li:nth-child(n+2){
  padding-top: 0.5rem;
}

hr.custom-hr{
  border: 0; border-top: 1.4px solid #1E1E1E;
  margin: 1em 0; padding: 0;
}

.height-60px{
  height: 60px;
  width: auto;
}

td.custom-td {
    vertical-align: middle;
}

td.custom-td img {
    vertical-align: middle;
    display: inline-block;
    margin-right: 0.6rem;
}

td.custom-td .inline-block{
  vertical-align: middle;
  display: inline-block;
}

td.custom-td .tagline{
  text-align: left;
}
</style>
